var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFaq(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      color: "#fff"
    },
    "aria-hidden": "true",
    focusable: "false",
    "data-prefix": "fa-light",
    "data-icon": "message-question",
    className: "svg-inline--fa fa-message-question fa-w-16",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 280c-11.04 0-20 8.953-20 20C236 311 244.1 320 256 320s20-8.955 20-20C276 288.1 267 280 256 280zM448 0H64C28.75 0 0 28.75 0 63.1v287.1C0 387.2 28.75 415.1 64 415.1h96v83.1c0 9.838 11.03 15.5 19.12 9.649L304 415.1H448c35.25 0 64-28.75 64-63.1V63.1C512 28.75 483.3 0 448 0zM480 352c0 17.6-14.4 32-32 32h-144.1c-6.928 0-13.67 2.248-19.21 6.406L192 460v-60c0-8.838-7.164-16-16-16H64c-17.6 0-32-14.4-32-32V64c0-17.6 14.4-32 32-32h384c17.6 0 32 14.4 32 32V352zM278.1 96H229.7C200.1 96 176 120.1 176 149.6c0 8.844 7.156 16 16 16s16-7.156 16-16C208 137.7 217.7 128 229.7 128h48.47C292.4 128 304 139.6 304 153.9c0 9.875-5.469 18.75-14.53 23.27L248.6 198.3C243.3 201.1 240 206.6 240 212.5V240C240 248.8 247.2 256 256 256s16-7.156 16-16V222.3l32-16.61c19.75-9.875 32-29.76 32-51.82C336 121.9 310 96 278.1 96z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.76afb297602c56beddfbd570e85e5c86.svg";
export { ForwardRef as ReactComponent };